export default "__VITE_PUBLIC_ASSET__434c9449__"